import React from 'react'
import { useMediaQuery } from 'react-responsive'

const maxMobileQuery = 992

export const ResponsiveContext = React.createContext({
  maxMobileQuery: null,
  isMobile: false,
})

const ResponsiveContextProvider = ({ children }) => {
  const isMobile = useMediaQuery({ query: `(max-width: ${maxMobileQuery}px)` })

  return (
    <ResponsiveContext.Provider
      value={{
        maxMobileQuery,
        isMobile,
      }}
    >
      {children}
    </ResponsiveContext.Provider>
  )
}

export default ResponsiveContextProvider
